import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { Users, Building2 } from 'lucide-react';
import ClientsManagement from './ClientsManagement';
import CompaniesAdminPage from './CompaniesAdminPage';

/**
 * Hub "Gestion des Clients" — page parent avec deux onglets :
 *  • Utilisateurs (vue legacy ClientsManagement)
 *  • Entreprises (CompaniesAdminPage : tableau, multi-select, bulk, profil)
 *
 * URL : /admin/clients?tab=users | ?tab=companies (default: users)
 */
export default function ClientsHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialTab = searchParams.get('tab') === 'companies' ? 'companies' : 'users';
  const [tab, setTab] = useState(initialTab);

  useEffect(() => {
    const t = searchParams.get('tab') === 'companies' ? 'companies' : 'users';
    if (t !== tab) setTab(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const onTabChange = (value) => {
    setTab(value);
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="p-4 md:p-6 space-y-4" data-testid="clients-hub-page">
      <Tabs value={tab} onValueChange={onTabChange} className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="users" data-testid="tab-trigger-users">
            <Users className="w-4 h-4 mr-2" />Utilisateurs
          </TabsTrigger>
          <TabsTrigger value="companies" data-testid="tab-trigger-companies">
            <Building2 className="w-4 h-4 mr-2" />Entreprises
          </TabsTrigger>
        </TabsList>
        <TabsContent value="users" className="mt-4">
          <ClientsManagement />
        </TabsContent>
        <TabsContent value="companies" className="mt-4">
          <CompaniesAdminPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
